import React, { useState, useRef } from "react";
import axios from "axios";


const useBib = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, values }) => { },
}) => {
    const [data, setData] = useState([])
    const [newBibData, setNewBibData] = useState([])
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck([])
    const abortControllerRef = useRef(null); // 新增一個 ref 存 controller

    const getNewBibData = (params) => {

        onBefore({
            axiosMode: "get"
        })
        return axios.get('/koha/bib', {
            params: {
                field: "keyword",
                order: setOrders({
                    "bib_datecreated": "descend"
                }),
                size: 5,
                cur_page: 1,
                ...params
            },
        })
            .then((response) => {
                let data = response.data
                setNewBibData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            api: 'newBibData'
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            api: 'newBibData'
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const getBibData = (params) => {
        // 取消前一次請求
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        const controller = new AbortController();
        abortControllerRef.current = controller;

        onBefore({ axiosMode: "get", values: params })
        return axios.get('/koha/bib', {
            params: params,
            signal: controller.signal,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })

                return {
                    ...data
                }
            })
            .catch((error) => {
                if (axios.isCancel(error) || error.name === 'CanceledError') {
                    // console.log("Request canceled", error.message);
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error"
                    });
                }
            });
    }
    const postBibData = (data) => {
        onBefore({
            axiosMode: "post", values: data
        })
        return axios.post('/koha/bib',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                onFinish({ axiosMode: "post", status: status === "success" ? "success" : "error", values: responseData })
                return {
                    status: status === "success" ? "success" : "error",
                    message: responseData?.message,
                    data: responseData
                }
            })
            .catch((ex) => {
                onFinish({ axiosMode: "post", status: "error", values: ex })
            })

    }
    const patchBibData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        return axios.patch('/koha/bib',
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                    return {
                        status: status === "success" ? "success" : "error",
                        message: responseData?.message,
                        data: responseData // <--- 加這行
                    }
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: responseData
                        }
                    )
                    return {
                        status: status === "success" ? "success" : "error",
                        message: responseData?.message,
                        data: responseData // <--- 加這行

                    }
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteBibData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/koha/bib',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const getBibInfoFormat = () => {
        let infoFormatData = [

            {
                language_name: "bib_title",
                valueKeys: ['bib_title'],
                isJoin: false
            },
            {
                language_name: "classification_number",
                valueKeys: ['bibitem_cn_class'],
                isJoin: false
            },
            {
                language_name: "author_number",
                valueKeys: ['bibitem_cn_item'],
                isJoin: false
            },
            {
                language_name: "biblionumber",
                valueKeys: ['bib_biblionumber'],
                isJoin: false
            },
            {
                language_name: "import_bibliography_date",
                valueKeys: ['bib_datecreated'],
                isJoin: false
            },
            {
                language_name: "Author",
                valueKeys: ['bib_author'],
                isJoin: false
            },
            {
                language_name: "bib_translator",
                valueKeys: ['bib_translator'],
                isJoin: true
            },
            {
                language_name: "Material_type",
                valueKeys: ['bib_materialType'],
                isJoin: false
            },
            {
                language_name: "Language",
                valueKeys: ['bib_language'],
                isJoin: false
            },
            {
                language_name: "Series",
                valueKeys: ['bib_seriestitle', 'bibitem_volume'],
                isJoin: false
            },


            {
                language_name: "ISBN",
                valueKeys: ['bibitem_isbn'],
                isJoin: false
            },
            {
                language_name: "Edition",
                valueKeys: ['bibitem_editionstatement'],
                isJoin: false
            },
            {
                language_name: "online_resources",
                valueKeys: ['bib_electronic_location', 'bib_electronic_location_name'],
                isJoin: false
            },
            {
                language_name: "Publication_details",
                valueKeys: ['bib_publisher'],
                isJoin: false
            },
            {
                language_name: "Description",
                valueKeys: ['bib_notes'],
                isJoin: false
            },
            {
                language_name: "Other_title",
                valueKeys: ['bib_othertitle'],
                isJoin: true
            },

        ]
        return infoFormatData
    }

    return {
        BibData: data,
        newBibData,
        getBibData,
        getNewBibData,
        postBibData,
        patchBibData,
        deleteBibData,
        getBibInfoFormat
    }
}
export { useBib }



const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
